export default {
  error: 'Erro',
  sorry: 'Desculpe, recebemos o seguinte erro',
  workingOnIt:
    'Um engenheiro foi notificado desse problema e estamos trabalhando para resolver o assunto o mais rápido possível.',
  tryAgain: 'Por favor, tente novamente mais tarde',
  noInternet:
    'Parece haver um problema com sua conexão com a internet. Por favor verifique e tente novamente.',
}
